import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// attach bearer token as fallback (cookie is primary)
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('hibret_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem('hibret_token', t);
  else localStorage.removeItem('hibret_token');
};

// Normalize FastAPI/Pydantic error payloads so `error.response.data.detail` is
// ALWAYS a plain string. This prevents "Objects are not valid as a React child"
// crashes when a 422 validation detail (an array of objects) is passed to a toast.
function detailToString(detail) {
  if (detail == null) return '';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (typeof d === 'string' ? d : d?.msg || d?.detail || JSON.stringify(d)))
      .filter(Boolean)
      .join(', ');
  }
  if (typeof detail === 'object') return detail.msg || detail.detail || JSON.stringify(detail);
  return String(detail);
}

client.interceptors.response.use(
  (res) => res,
  (error) => {
    const data = error?.response?.data;
    if (data && typeof data === 'object' && 'detail' in data) {
      data.detail = detailToString(data.detail);
    }
    return Promise.reject(error);
  }
);

export const getToken = () => localStorage.getItem('hibret_token');

export default client;

// download helper returns object URL for preview
export async function fetchFileBlob(docId) {
  const res = await client.get(`/documents/${docId}/download`, { responseType: 'blob' });
  return URL.createObjectURL(res.data);
}

// download a CSV (or any blob) from an authenticated endpoint
export async function downloadCsv(path, filename) {
  const res = await client.get(path, { responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
